import { useMutation } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { completeEntraIdSetup } from '../../api/portalServices';
import { useSession } from '../../common/authorization/context/Session';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import { type ApiError, AppError } from '../../errorHandler/errors';
import { PortalPath } from '../PortalRoutes';
import useEntraIdInitialSync from './useEntraIdInitialSync';

const useEntraIdSetupComplete = () => {
  const { emitError } = useErrorContext();
  const { mutate: startInitialSync } = useEntraIdInitialSync();
  const { tenantId } = useSession();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useMutation({
    mutationFn: async (tenantId: string) => {
      await completeEntraIdSetup(tenantId);
    },
    onSuccess: async () => {
      console.log('Entra ID setup completed');
      startInitialSync(tenantId || '');
    },
    onError: (e: Error) => {
      console.log('Entra ID setup failed', e);
      const apiError = e as unknown as ApiError;
      emitError(new AppError(apiError));
      const params = new URLSearchParams(searchParams);
      navigate({ pathname: PortalPath.SETTINGS, search: `?${params.toString()}` });
    },
  });
};

export default useEntraIdSetupComplete;
